(function () {
  var root = document.querySelector('[data-journey]');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var track = root.querySelector('.journey__track');
  var space = root.querySelector('[data-layer="space"]');
  var look = root.querySelector('[data-layer="look"]');
  var video = root.querySelector('.j-look__video');
  var vignette = root.querySelector('[data-layer="vignette"]');
  var phases = [].slice.call(root.querySelectorAll('.j-phase'));
  var footer = document.querySelector('.footer');

  if (window.innerWidth < 990) {
    phases.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.pointerEvents = 'auto';
      el.style.position = 'relative';
    });
    if (track) track.style.height = 'auto';
    return;
  }

  var target = 0;
  var current = 0;

  function progressFromScroll() {
    if (!track) return 0;
    var rect = track.getBoundingClientRect();
    var totalH = Math.max(1, track.offsetHeight - window.innerHeight);
    var raw = -rect.top / totalH;
    if (raw < 0) return 0;
    if (raw > 1) return 1;
    return raw;
  }

  function hold(p, a, b) {
    var fi = 0.035;
    var fo = 0.04;
    if (p <= a || p >= b) return 0;
    if (p < a + fi) return (p - a) / fi;
    if (p > b - fo) return (b - p) / fo;
    return 1;
  }

  function apply(p) {
    var dive = Math.max(0, (p - 0.06) / 0.94);
    var heroGone = Math.min(1, p / 0.22);

    if (space) {
      space.style.opacity = '1';
      space.style.transform = 'scale(' + (1.04 + dive * 0.9) + ')';
    }
    if (look) {
      look.style.transform = 'translate3d(0,' + (dive * -8) + 'vh,0) scale(' + (1.02 + heroGone * 1.35) + ')';
      look.style.opacity = String(1 - heroGone);
    }
    if (vignette) {
      vignette.style.opacity = String(0.1 + Math.max(0, p - 0.82) * 1.2);
    }

    phases.forEach(function (el) {
      var a = parseFloat(el.getAttribute('data-in'));
      var b = parseFloat(el.getAttribute('data-out'));
      var vis = hold(p, a, b);
      el.style.opacity = String(vis);
      el.style.transform = 'translate3d(0,' + ((1 - vis) * 18) + 'px,' + (-90 + vis * 90) + 'px) scale(' + (0.96 + vis * 0.04) + ')';
      el.style.pointerEvents = vis > 0.55 ? 'auto' : 'none';
    });

    if (footer) {
      var show = Math.max(0, (p - 0.88) / 0.12);
      footer.style.opacity = String(0.15 + show * 0.85);
    }
  }

  function catsVisible() {
    var cats = root.querySelector('.j-cats');
    if (!cats) return null;
    var phase = cats.closest('.j-phase');
    if (!phase) return null;
    if (parseFloat(phase.style.opacity || '0') < 0.25) return null;
    return cats;
  }

  function activeCardIndex(e, cards) {
    var i = Math.floor((e.clientX / window.innerWidth) * cards.length);
    if (i < 0) i = 0;
    if (i > cards.length - 1) i = cards.length - 1;
    return i;
  }

  document.addEventListener('mousemove', function (e) {
    var cards = root.querySelectorAll('a.j-cat');
    var i;
    for (i = 0; i < cards.length; i++) cards[i].classList.remove('is-hot');
    var cats = catsVisible();
    if (!cats) return;
    if (e.clientY < window.innerHeight * 0.28 || e.clientY > window.innerHeight * 0.92) return;
    cards = cats.querySelectorAll('a.j-cat');
    if (!cards.length) return;
    cards[activeCardIndex(e, cards)].classList.add('is-hot');
  });

  document.addEventListener('click', function (e) {
    var cats = catsVisible();
    if (!cats) return;
    if (e.clientY < window.innerHeight * 0.28 || e.clientY > window.innerHeight * 0.92) return;
    var cards = cats.querySelectorAll('a.j-cat');
    if (!cards.length) return;
    var card = cards[activeCardIndex(e, cards)];
    var url = card.getAttribute('data-cat-url') || card.getAttribute('href');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(url);
  }, true);

  if (reduce) {
    apply(0.08);
    return;
  }

  function tick() {
    target = progressFromScroll();
    current += (target - current) * 0.04;
    if (Math.abs(target - current) < 0.0003) current = target;
    apply(current);
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
  if (video && video.play) video.play().catch(function () {});
})();